import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import CreatorProfile from './pages/CreatorProfile';
import ExploreCreators from './pages/ExploreCreators';
import CreatorSupporters from './pages/CreatorSupporters';
import SinglePost from './pages/SinglePost';
import CreatorPage from './pages/CreatorPage';
import CreatorSettings from './pages/CreatorSettings';
import AdminDashboard from './pages/AdminDashboard';
import Messages from './pages/Messages';
import CreatorDashboard from './pages/CreatorDashboard';
import SupporterDashboard from './pages/SupporterDashboard';
import FeedPage from './pages/FeedPage';
import RoleBasedDashboard from './components/RoleBasedDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import PaymentSuccess from './pages/PaymentSuccess';
import { PrivacyPolicy, TermsOfService, CookiePolicy, RefundPolicy } from './pages/LegalPages';
import DiscoverCreators from './pages/Creators';
import { ForgotPassword, ResetPassword } from './pages/PasswordRecovery';
import './App.css';

function AppContent() {
  const location = useLocation();
  const shouldShowFooter = !location.pathname.includes('/creator-dashboard') && !location.pathname.includes('/messages');
  
  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/feed" element={<FeedPage />} />
          
          {/* MESSAGES ROUTE - SADA PRIHVATA I /messages/list */}
          <Route path="/messages/:userId" element={
            <ProtectedRoute>
              <Messages />
            </ProtectedRoute>
          } />
          
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<CookiePolicy />} />
		  <Route path="/:username/post/:postId" element={<SinglePost />} />
          <Route path="/refunds" element={<RefundPolicy />} />
          <Route path="/explore-creators" element={<ExploreCreators />} />
          <Route path="/creators" element={<DiscoverCreators />} />
          
          {/* DYNAMIC PROFILE ROUTE */}
          <Route path="/:username" element={<CreatorProfile />} />
          
          <Route path="/dashboard" element={<RoleBasedDashboard />} />
          <Route path="/admin-dashboard" element={<ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/creator-dashboard" element={<ProtectedRoute requiredRole="creator"><CreatorDashboard /></ProtectedRoute>} />
          <Route path="/creator/supporters" element={<ProtectedRoute requiredRole="creator"><CreatorSupporters /></ProtectedRoute>} />
          <Route path="/creator/settings" element={<ProtectedRoute requiredRole="creator"><CreatorSettings /></ProtectedRoute>} />
          <Route path="/creator/:section" element={<ProtectedRoute requiredRole="creator"><CreatorPage /></ProtectedRoute>} />
          <Route path="/supporter-dashboard" element={<ProtectedRoute requiredRole="supporter"><SupporterDashboard /></ProtectedRoute>} />
        </Routes>
      </main>
      {shouldShowFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
